// components/Services/Services.jsx
import React from 'react';
import './Services.css';

const Services = () => {
  // Datos de servicios principales
  const servicesData = [
    {
      id: 1,
      title: 'Cercos perimetrales',
      image: '/img/services/IMG9.jpeg',
      fallbackIcon: 'fas fa-home',
      description: 'Venta e Instalación de cercos para tu seguridad'
    },
    {
      id: 2,
      title: 'Postes de Hormigón',
      image: '/img/services/IMG6.jpeg',
      fallbackIcon: 'fas fa-industry',
      description: 'Venta e Instalación de postes de hormigón en todas las medidas'
    },
    {
      id: 3,
      title: 'Postes de quebracho colorado',
      image: '/img/services/IMG10.jpeg',
      fallbackIcon: 'fas fa-industry',
      description: 'Venta e Instalación de postes de quebracho colorado'
    },
    {
      id: 4,
      title: 'Tejido romboidal',
      image: '/img/services/IMG5.jpeg',
      fallbackIcon: 'fas fa-tools',
      description: 'Tejido romboidal galvanizado para cerramientos tradicionales'
    },
   
    
    {
      id: 5,
      title: 'Portones, Puertas y Tranqueras',
      image: '/img/services/IMG1.jpeg',
      fallbackIcon: 'fas fa-gate-open',
      description: 'Portones, puertas y tranqueras personalizados a medida o standard según tus necesidades específicas'
    },
    
    {
      id: 6,
      title: 'Alambre de púas',
      image: '/img/services/IMG2.jpeg',
      fallbackIcon: 'fas fa-exclamation-triangle',
      description: 'Alambre de púas para mejorar la seguridad del cerco'
    },
    {
      id: 7,
      title: 'Concertinas',
      image: '/img/services/IMG12.jpeg',
      fallbackIcon: 'fas fa-shield-alt',
      description: 'Venta de Concertinas cruzadas para máxima seguridad y protección'
    },
    {
      id: 8,
      title: 'Paneles acmafor',
      image: '/img/services/IMG7.jpeg',
      fallbackIcon: 'fas fa-shield-alt',
      description: 'Paneles acmafor de alta calidad para cerramientos modernos'
    },
    
    {
      id: 9,
      title: 'Mallas Electrosoldadas',
      image: '/img/services/IMG11.jpeg',
      fallbackIcon: 'fas fa-seedling',
      description: 'Venta de mallas electrosoldadas para diferentes usos'
    },
    {
      id: 10,
      title: 'Césped sintético',
      image: '/img/services/IMG3.jpeg',
      fallbackIcon: 'fas fa-seedling',
      description: 'Venta e instalación de césped sintético deportivo y urbano'
    },
    {
      id: 11,
      title: 'Cinta cubrecerco',
      image: '/img/services/IMG8.jpeg',
      fallbackIcon: 'fas fa-tape',
      description: 'Venta e instalación de cinta cubrecerco para un acabado estético'
    },
    {
      id: 12,
      title: 'Cerco olímpico',
      image: '/img/services/IMG4.jpeg',
      fallbackIcon: 'fas fa-running',
      description: 'Instalación de cercos olímpicos'
    }
  ];

  // Beneficios de la empresa
  const benefits = [
    {
      id: 1,
      title: 'Instalación profesional',
      
     
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
        </svg>
      )
    },
    {
      id: 2,
      title: 'Flete a domicilio',
      
     
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
        </svg>
      )
    },
    {
      id: 3,
      title: 'Gerenciamiento de obras',
      
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
        </svg>
      )
    },
    {
      id: 4,
      title: 'Asesoramiento técnico',
      
     
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      )
    },
    {
      id: 5,
      title: 'Servicio postventa',
      
     
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
        </svg>
      )
    }
  ];

  const handleImageError = (e, fallbackIcon) => {
    const imageContainer = e.target.parentNode;
    e.target.style.display = 'none';
    
    const iconElement = document.createElement('i');
    iconElement.className = fallbackIcon;
    iconElement.style.fontSize = '4rem';
    iconElement.style.color = '#3A8079';
    iconElement.style.zIndex = '1';
    imageContainer.appendChild(iconElement);
  };

  const handleContactClick = () => {
    // Scroll suave al formulario de contacto
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="servicios" className="services-all-options">
      {/* Servicios Principales */}
      <div className="services-section">
        <div className="services-header">
          <h2>NUESTROS SERVICIOS</h2>
          <p className="services-subtitle">
            Ofrecemos soluciones integrales en alambrados y cerramientos con la más alta calidad
          </p>
        </div>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-image">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="service-photo"
                  onError={(e) => handleImageError(e, service.fallbackIcon)}
                />
                <div className="service-overlay">
                  <p className="service-description">{service.description}</p>
                </div>
                <div className="service-title">{service.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Divisor de sección */}
      <div className="section-divider">
        <div className="divider-line"></div>
        <div className="divider-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
          </svg>
        </div>
        <div className="divider-line"></div>
      </div>

      {/* Beneficios */}
      <div className="benefits-section">
        <div className="benefits-header">
          <h3>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
            </svg>
            Beneficios
          </h3>
        </div>
        
        <p className="benefits-subtitle">
          Trabajamos con compromiso y profesionalismo para brindarte la mejor experiencia en cada proyecto
        </p>

        <div className="benefits-list">
          {benefits.map((benefit) => (
            <div key={benefit.id} className="benefit-item">
              <div className="benefit-icon">
                {benefit.icon}
              </div>
              <div className="benefit-info">
                <h4 className="benefit-title">{benefit.title}</h4>
                <p className="benefit-description">{benefit.description}</p>
                <p className="benefit-availability">{benefit.availability}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;